import React, { FC } from 'react';
import styled from 'styled-components';
import { ProjectTemplateData } from 'data/templates/projects';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { unreachable } from 'utils/unreachable';
import { RenderProjectPhaseName } from './project-phase-name';
import { RenderTaskName } from './task-name';

const FOCUS_WRAPPER_LAYER_ZINDEX = 1;

const FocusWrapper = styled.div<{ width }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  width: ${({ width }) => width};
  border: solid 2px transparent;
  transition: border-color ease-in var(--animation-duration-fast);
`;

const DetailCell = styled.div`
  position: relative;
  width: 100%;
  z-index: ${FOCUS_WRAPPER_LAYER_ZINDEX + 1};

  &:focus-within + ${FocusWrapper} {
    border-color: var(--primary-color);
    z-index: ${FOCUS_WRAPPER_LAYER_ZINDEX};
  }
`;

const renderCell = (
  data: ProjectTemplateData,
  onClick: () => void,
  index: number,
  parentTotal: number,
  autoFocus: boolean,
  performAutoFocus: () => void,
) => {
  switch (data.type) {
    case 'PROJECT_PHASE':
      return (
        <RenderProjectPhaseName
          id={data.id}
          onClick={onClick}
          autoFocus={autoFocus}
          performAutoFocus={performAutoFocus}
        />
      );
    case 'TASK':
      return (
        <RenderTaskName
          id={data.id}
          index={index}
          parentTotal={parentTotal}
          level={data.level}
          autoFocus={autoFocus}
          onClick={onClick}
          performAutoFocus={performAutoFocus}
        />
      );
    default:
      return unreachable(data);
  }
};

export const StatusNameCell: FC<{
  data: ProjectTemplateData;
  index: number;
  parentTotal: number;
  autoFocus: boolean;
  performAutoFocus(): void;
  onClick(): void;
}> = ({ data, index, parentTotal, autoFocus, performAutoFocus, onClick }) => {
  const [isTimesheetFeatureEnabled] = useAccountFeature(
    AccountFeature.Timesheets,
  );

  return (
    <>
      <DetailCell>
        {renderCell(
          data,
          onClick,
          index,
          parentTotal,
          autoFocus,
          performAutoFocus,
        )}
      </DetailCell>
      {data.data.isNew && (
        <FocusWrapper width={isTimesheetFeatureEnabled ? '374px' : '556px'} />
      )}
    </>
  );
};
